// extracted by mini-css-extract-plugin
module.exports = {"styles":"_2in4u5DjPcdE-YsBJPFHGD"};